import React, { useEffect, useState } from 'react';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

const StepSwitcher = ({
  step,
  formData,
  brandName,
  lang,
  langId,
  translationForReg,
  countryData,
  currencyData,
  defaultCountryId,
  defaultCurrencyId,
  defaultPromoCode,
  finishBtn,
  regFormTitle,
  landingName,
  regWith,
  isNeedlog
}) => {

  // Init Recaptcha
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [token, setToken] = useState('');

  useEffect(() => {
    getToken();
  }, [executeRecaptcha])

  // Получаем TOKEN капчи
  const getToken = async () => {
    if (!executeRecaptcha) {
      console.error('Execute recaptcha not yet available');
      return;
    }
    const token = await executeRecaptcha('registration')
    setToken(token)
  }

  switch (step) {
    case 1:
      return (
        <Step1
          brandName={brandName}
          lang={lang}
          langId={langId}
          translationForReg={translationForReg}
          countryData={countryData}
          currencyData={currencyData}
          prevData={formData}
          token={token}
          executeRecaptcha={executeRecaptcha}
          defaultCountryId={defaultCountryId}
          defaultCurrencyId={defaultCurrencyId}
          defaultPromoCode={defaultPromoCode}
          regFormTitle={regFormTitle}
          landingName={landingName}
          regWith={regWith}
        />
      );
    case 2:
      return (
        <Step2
          brandName={brandName}
          lang={lang}
          langId={langId}
          translationForReg={translationForReg}
          formData={formData}
          token={token}
          regFormTitle={regFormTitle}
        />
      );
    case 3:
      return (
        <Step3
          brandName={brandName}
          lang={lang}
          langId={langId}
          translationForReg={translationForReg}
          finishBtn={finishBtn}
          regFormTitle={regFormTitle}
          isNeedlog={isNeedlog}
        />
      );
  }

}

export default StepSwitcher;
